import Experience from "./Experience/Experience.js";
import Functions from "./Experience/World/Functions.js";

async function initializeApplication() {
  const experience = new Experience();

  // If Experience has an async init method, wait for it.
  if (experience.init instanceof Function) {
    await experience.init();
  }

  const functions = new Functions(experience);

  // Make the mode switcher globally available
  window.changeModeMethod = functions.handleMessage.bind(functions);
}

// Start the app safely
initializeApplication();
